import { Link } from "react-router-dom";

import SEO from "../../components/SEO";
import Footer from "../../components/layout/Footer";
import Header from "../../components/layout/Header";
import { SITE_URL } from "../../config/site";

import "./NotFoundPage.css";

export default function NotFoundPage() {
  return (
    <>
      <SEO
        title="Página no encontrada | Imalandia"
        description="La página que buscas no existe o ha cambiado de dirección."
        canonical={`${SITE_URL}/404`}
        noindex
      />

      <Header />

      <main className="not-found-page">
        <section className="not-found-card" aria-labelledby="not-found-title">
          <p className="not-found-code">404</p>
          <p className="not-found-eyebrow">Página no encontrada</p>
          <h1 id="not-found-title">Este recuerdo no está aquí</h1>
          <p className="not-found-copy">
            Puede que el enlace haya cambiado o que la dirección no sea
            correcta. Puedes volver al inicio o crear tus imanes personalizados.
          </p>

          <div className="not-found-actions">
            <Link className="not-found-primary" to="/">
              Volver al inicio
            </Link>
            <Link
              className="not-found-secondary"
              to="/imanes-personalizados-con-fotos"
            >
              Crear imanes
            </Link>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}
